import type { ReactNode } from 'react';

import { faCircleExclamation } from '@awesome.me/kit-f3dc60f0d0/icons/classic/solid';
import { Trans } from '@lingui/react/macro';

import { StatusMessage } from '@/common-components/elements/StatusMessage/StatusMessage';

interface InvalidLinkMessageProps {
  /** Pass `null` to suppress the heading entirely. */
  heading?: ReactNode | null;
  message?: ReactNode;
}

export const InvalidLinkMessage = ({
  heading = <Trans>Invalid Link</Trans>,
  message,
}: InvalidLinkMessageProps) => {
  return (
    <StatusMessage
      icon={faCircleExclamation}
      iconClassName="vai-h-6 vai-w-6 vai-text-red-600"
      circleClassName="vai-bg-red-100"
      heading={heading}
      message={
        message ?? (
          <Trans>
            This link appears to be incomplete. Please use the link provided to
            access the pre-qualification form.
          </Trans>
        )
      }
    />
  );
};
